import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { Leaf, Sprout, HandHeart } from "lucide-react";
import { PRE_HARVEST_MODE } from "@/lib/siteMode";

const ICONS = [Sprout, Leaf, HandHeart];

export default function Commitment() {
  const { t } = useLang();
  const items = t("commitment.items");

  return (
    <section
      id="compromiso"
      data-testid="commitment-section"
      className="relative bg-cream-100 py-24 sm:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-2xl">
          <span className="text-[11px] uppercase tracking-[0.32em] text-gold-deep font-medium">
            {t("commitment.overline")}
          </span>
          <h2 className="mt-6 font-serif text-4xl sm:text-5xl leading-[1.05] text-olive-900 font-medium">
            {t("commitment.h2_a")} <span className="italic">{t("commitment.h2_b")}</span>
            {t("commitment.h2_c")}.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-0 border-t border-olive-700/15">
          {PRE_HARVEST_MODE && (
            <div
              data-testid="commitment-reference-note"
              className="md:col-span-3 pb-6 pt-4"
            >
              <p className="text-xs text-olive-800/50 border-l-2 border-gold-deep pl-3 italic">
                {t("pre_harvest.reference_note")}
              </p>
            </div>
          )}
          {items.map((it, i) => {
            const Icon = ICONS[i] || Leaf;
            return (
              <div
                key={it.title}
                data-testid={`commitment-card-${i}`}
                className={`p-8 lg:p-10 border-b border-olive-700/15 md:border-b-0 ${
                  i > 0 ? "md:border-l border-olive-700/15" : ""
                }`}
              >
                <Icon size={26} strokeWidth={1.1} className="text-gold-deep" />
                <div className="mt-8 text-[10px] uppercase tracking-[0.3em] text-olive-800/40">
                  0{i + 1} / 03
                </div>
                <h3 className="mt-3 font-serif text-2xl text-olive-900">{it.title}</h3>
                <p className="mt-3 text-olive-800/80 font-light leading-relaxed">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
